<template>
    <div class="home-container">
        <div class="home-banner">
            <div class="home-title">
                <h1>欢迎使用</h1>
                <h3>GT3D-Server</h3>
                <h2>跨平台、分布式、可扩展的服务器GIS软件开发平台</h2>
                <h2>@Copyright 厦门硅田系统工程优先公司 </h2>
            </div>
        </div>
        <div class="home-product">
            <div class="item">
                <div class="icon-service"></div>
                <div class="content">
                    <span class="paddingtop30">服务管理</span>
                    <span class="paddingtop30">您可以通过该页面查询、访问 GIS 服务。</span>
                    <div class="link paddingtop30">
                        <el-link href="#" target="_blank">点击进入</el-link>
                        <img src="@/assets/images/arrow.svg" width="11" height="9" />
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="icon-data"></div>
                <div class="content">
                    <span class="paddingtop30">数据管理</span>
                    <span class="paddingtop30">您可以通过该页面查询、管理基础数据。</span>
                    <div class="link paddingtop30">
                        <el-link href="#" target="_blank">点击进入</el-link>
                        <img src="@/assets/images/arrow.svg" width="11" height="9" />
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="icon-demo"></div>
                <div class="content">
                    <span class="paddingtop30">示范程序</span>
                    <span class="paddingtop30">查看GT3D API。</span>
                    <div class="link paddingtop30">
                        <el-link href="http://gtserver.xmguitian.com:8092/api/examples/examples.html" target="_blank">点击进入</el-link>
                        <img src="@/assets/images/arrow.svg" width="11" height="9" />
                    </div>
                </div>
            </div>
        </div>
        <div class="home-other">
            <div class="item">
                <div class="demo-content">
                    <h2 class="title">经典案例</h2>
                    <div class="links">
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/cangnan/" target="_blank">孪生平台</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/chadi/ui" target="_blank">数字乡村</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/sec/manage-ui" target="_blank">安全纵横</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/gl/html" target="_blank">资产管理</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/fw-admin/" target="_blank">烟花爆竹</el-link>
                        <el-link class="title paddingtop20" href="https://api.xmguitian.com:8443/app/VR/" target="_blank">VR视频演示</el-link>
                        <el-link class="title paddingtop20" href="http://www.xmguitian.com:8011/" target="_blank">物联网平台</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/app/cnfc/" target="_blank">乡村大数据</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/app/cnbd/" target="_blank">运行指挥中心</el-link>
                        <el-link class="title paddingtop20" href="http://www.xmguitian.com:9090/hy/html" target="_blank">海洋渔船系统</el-link>
                        <el-link class="title paddingtop20" href="http://gtserver.xmguitian.com:8092/app/boat/ui" target="_blank">海南游艇官网</el-link>
                    </div>
                </div>
                <div class="demo-img">
                    <img src="@/assets/images/demo.png" width="460" height="260" />
                </div>
            </div>
            <div class="item">
                <div class="img">
                    <img src="@/assets/images/demo/1.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/2.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/3.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/4.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/5.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/6.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/7.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/8.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/9.jpg" width="110" height="112" />
                </div>
                <div class="img">
                    <img src="@/assets/images/demo/10.jpg" width="110" height="112" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {}
}
</script>

<style lang="scss" scoped>
.home-container {
    background: #f2f2f2;
    padding-bottom: 50px;
    .home-other {
        width: 1398px;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 50px;
        .item {
            padding: 30px 50px;
            width: 580px;
            height: 280px;
            background: white;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .demo-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                h2 {
                    font-family: 微软雅黑;
                    font-size: 20px;
                    font-weight: 500;
                }
                .links {
                    display: flex;
                    flex-direction: column;
                    height: 254px;
                    overflow-x: auto;
                }
                /deep/.el-link {
                    font-size: 16px !important;
                }
            }
            .demo-img {
                width: 460px;
                height: 260px;
                margin-top: 10px;
            }
        }
    }
    .home-product {
        width: 1398px;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 50px;
        margin-bottom: 50px;
        .item {
            background: white;
            width: 350px;
            height: 220px;
            padding: 30px 50px;
            .content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .link {
                    display: flex;
                    align-items: center;
                    img {
                        margin-left: 5px;
                    }
                }
            }
            .icon-service {
                background: url('../../assets/images/service.svg');
                width: 46px;
                height: 46px;
            }
            .icon-data {
                background: url('../../assets/images/data.svg');
                width: 46px;
                height: 46px;
            }
            .icon-demo {
                background: url('../../assets/images/demo.svg');
                width: 46px;
                height: 46px;
            }
        }
    }
    .home-banner {
        background: url('../../assets/images/banner.png');
        width: 100%;
        height: calc(100vw * (584 / 1920));
        background-size: cover;
        display: flex;
        line-height: 1.1;
        .home-title {
            width: 1398px;
            margin: auto;
            color: white;
            text-align: left;
            h3 {
                font-family: 'Arial';
                font-size: 48px;
                margin-bottom: 20px;
                font-weight: 500;
            }
            h2 {
                font-family: 微软雅黑;
                font-size: 20px;
                font-weight: 500;
            }
            h1 {
                margin-top: 10px;
                font-size: 32px;
                font-family: 'Arial';
                margin-bottom: 10px;
                font-weight: 500;
            }
        }
    }
}
.paddingtop30 {
    padding-top: 30px;
}
.paddingtop20 {
    padding-top: 20px;
}
</style>
